import {
  boldSerializer,
  italicSerializer,
  linkMarkSerializer,
  mentionMarkSerializer,
} from './mark';
import {
  paragraphSerializer,
  textSerializer,
  headingSerializer,
  emphasisSerializer,
  listItemSerializer,
  quoteSerializer,
  imageSerializer,
} from './nodes';
import { Serializer } from './Serializer';

const articleSerializer = new Serializer({
  nodeSerializers: [
    textSerializer,
    headingSerializer,
    paragraphSerializer,
    emphasisSerializer,
    listItemSerializer,
    quoteSerializer,
    imageSerializer,
  ],
  markSerializers: [
    boldSerializer,
    italicSerializer,
    linkMarkSerializer,
    mentionMarkSerializer,
  ],
});

export { articleSerializer };
